import { FBase } from "./firebase.base";
import { isObject } from "@pineapplelab/util";
import { DocumentReference } from "@angular/fire/compat/firestore";

export class UserRole extends FBase {

  roles: UserRole.UserRoleObjectSubmodel[] = [];

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}


export namespace UserRole {

  export interface UserRoleObjectSubmodel {
    id: string;
    name: string;
    reference: DocumentReference;
  }
  export const PATH = 'userRoles';

}
